var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"md:mx-14 mx-4"},[_c('app-tour',{attrs:{"tourDetails":_vm.bulkPayoutTour,"tourComponent":"bulkPayout","displayTour":_vm.displayTour},on:{"stopTour":_vm.stopTour}}),(_vm.isDefaultBulkPayoutScreen)?_c('initiate-tour-button',{on:{"startTour":_vm.startBulkPayoutTour}}):_vm._e(),_c(_vm.activeComponent,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }